import {
  Alert as ReactAlert,
  Pagination as ReactPagination,
  Spinner as ReactSpinner,
} from '@a-ui/react';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import NewsletterCard from '../../components/NewsletterCard';
import Typography from '../../components/Typography';
import useApi from '../../hooks/api.hooks';
import { translate } from '../../i18n';

const NewsletterOverview: React.FC = () => {
  const overviewRef = React.useRef<HTMLDivElement>(null);
  const [isChangingPage, setIsChangingPage] = React.useState(false);
  const history = useHistory();
  const { search } = useLocation();
  const params = React.useMemo(() => new URLSearchParams(search), [search]);
  const page = React.useMemo(() => (params.has('page') ? Number(params.get('page')) : 1), [params]);
  const { data, isLoading, error } = useApi<Api.NewsletterResponse>(
    `/newsletters?${params.toString()}`,
  );

  React.useEffect(() => {
    if (!data?._embedded.resourceList.length || !isChangingPage) return;

    setIsChangingPage(false);
    overviewRef.current?.scrollIntoView();
  }, [data]);

  const handlePageChange = (newPage: number) => {
    params.set('page', newPage.toString());
    history.push({ search: params.toString() });

    setIsChangingPage(true);
  };

  if (isLoading) {
    return <ReactSpinner />;
  }

  return (
    <>
      {!error && data._embedded.resourceList.length > 0 && (
        <Typography classNames="u-margin-bottom u-text-light">
          {translate('newsletters.overview.results', { number: data._page.totalItems })}
        </Typography>
      )}

      <div className="row" ref={overviewRef}>
        {data?._embedded.resourceList.map((newsletter) => (
          <div
            key={`newsletter-${newsletter.listId}`}
            className="col-xs-12 col-lg-6 col-xl-4 u-margin-bottom"
          >
            <NewsletterCard
              title={newsletter.name}
              categories={newsletter.categories!}
              description={newsletter.description}
              listId={newsletter.listId}
            />
          </div>
        ))}
      </div>

      {(error || !data?._embedded.resourceList.length) && (
        <ReactAlert theme="danger">
          <Typography>{translate('error.server.unknown')}</Typography>
        </ReactAlert>
      )}

      {data?._embedded.resourceList.length > 0 && (
        <div className="ckp-o-newsletter__pagination">
          <ReactPagination
            currentPage={page}
            itemsPerPage={9}
            totalItems={data._page.totalPages * 9}
            onChange={handlePageChange}
          />
        </div>
      )}
    </>
  );
};

export default NewsletterOverview;
